export const SELECT_CUSTOMER_TO_WORK_WITH = "SELECT_CUSTOMER_TO_WORK_WITH";
export const SELECT_ADVISOR_AS_CUSTOMER = "SELECT_ADVISOR_AS_CUSTOMER";
export const RESET_CUSTOMER = "RESET_CUSTOMER";
